import { createRepoUrl } from './createRepoUrl';

export function applyCommitUrlTemplate(commitUrlTemplate: string, sha: string, branchName: string) {
  return createRepoUrl(commitUrlTemplate, { sha, branchName });
}
